import { EvolutionItem, Exam, FolderItem, Patient, SummaryData } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { generateHospitalisationSummaryHtml } from "./hospitalisationSummary";

export async function getFullPatientSummaryText({
    patient,
    parent,
  }: {
    patient: Patient;
    parent: FolderItem;
  }) {
    let exams = await apiFetch(
      "exams",
      "loadMany",
      {
        statuses: ["finished"],
        patientId: patient.id,
        parentId: parent?.id,
      },
      "Erreur lors du chargement des examens"
    );
  
    let evolutionItems = await apiFetch(
      "evolutionItems",
      "loadMany",
      {
        patientId: patient.id,
        parentId: parent?.id,
      },
      "Erreur lors du chargement de l'historique"
    );
  
    let summaryData: SummaryData = {
      conclusion: "",
      doctors: [],
      evolutionItems: (evolutionItems || []) as EvolutionItem[],
      exams: (exams?.exams || []) as Exam[],
      item: parent,
    };
    return await generateHospitalisationSummaryHtml({ summaryData });
  }
  